<template>
	<div>
		<v-container fluid grid-list-md>
			<v-layout row wrap>
			  <v-flex xs12>
			    <v-card>
			    <v-form
                id="update_visitor"
                @submit.prevent="updateVisitor"
                data-vv-scope="updateVisitor"
                ref="visitor_form"
                v-model="valid">
	                <v-card-text>
	                  <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
	                  	<v-layout row wrap>
	                  	  <v-flex xs12 sm6>
	                  	    <v-text-field
	                        name="Name"
	                        label="Name"
	                        id="id"
	                        v-model="visitor_object.name"
	                        
	                    	></v-text-field>
	                  	  </v-flex>
	                  	  <v-flex xs12 sm6>
	                  	  </v-flex>
	                  	</v-layout>
	                  	<v-layout row wrap>
	                  	  <v-flex xs12 sm6>
	                  	    <v-text-field
	                        name="Mobile"
	                        label="Mobile"
	                        id="id"
	                        v-model="visitor_object.mobile"
	                    	></v-text-field>
	                  	  </v-flex>
	                  	  <v-flex xs12 sm6>
	                  	    <v-text-field
	                        name="Email"
	                        label="Email"
	                        id="id"
	                        v-model="visitor_object.email"
	                    	></v-text-field>
	                  	  </v-flex>
	                  	</v-layout>
	                  </v-container>
	                </v-card-text>
	                <v-card-actions>
	              	<v-spacer></v-spacer>
	              		<v-btn color="primary" small :loading="loading" :disabled="loading" type="submit">Update</v-btn>
	              		<v-btn text small to="/visitors">Cancel</v-btn>
	          		</v-card-actions>
          		</v-form>
			    </v-card>
			  </v-flex>
			</v-layout>
		</v-container>	
	</div>
</template>
<script>
  export default {
  	watch:{
  		"user_object.first_name":{
        deep:true,
        handler(val)
        { 
          if(val)
          {
            this.user_object.first_name = val.charAt(0).toUpperCase() + val.slice(1);
          }
          
        }
      },
      "user_object.last_name":{
        deep:true,
        handler(val)
        { 
          if(val)
          {
            this.user_object.last_name = val.charAt(0).toUpperCase() + val.slice(1);
          }
          
        }
      },
      "user_object.role_id":{
        deep:true,
        handler(val)
        { 
          if(val)
          {
          	if(val.name == 'office_admin')
          	{
          		this.is_office_admin =true;
          	}
          	else{
          		this.is_office_admin =false;
          	}
            
          }
          
        }
      },
  	},
  	methods:{
			validateBeforeSubmit: function(scope) {  
		      this.$validator.validateAll(scope).then(result => {
		        if (result) {
		          this[scope]();
		        }
		     });
    		},
    		updateVisitor:function(){
    			this.loaders.submit_loader =true;
    		     axios.post(`${process.env.VUE_APP_API_URL}/api/visitors/`+this.$route.params.id + `/update`, this.visitor_object).then((response)=>{
				if(response.data.status == 1)
				{	  
				  this.$router.push({ name: 'showVisitorDetails',
				   params: {id: response.data.visitor.id}});
			      this.loaders.submit_loader =false;    
				}
				}).catch((error)=>{
				  console.log(error);
				}).finally(()=>{

				});	
    		},
    		getVisitorDetails:function() {
    			this.loaders.detail_loader = true;
		      axios
		        .get(
		          `${process.env.VUE_APP_API_URL}/api/visitors/` +
		            this.$route.params.id + `/edit`
		        )
		        .then(response => {		        	
		          if (response.data.status == 1) {
		            this.visitor_object = response.data.visitor;
		            this.loaders.detail_loader=false;

		          }
		        })
		        .catch(error => {
		         console.log(error);
		        })
		        .finally(() => {});
    		},
	        
    },
    data:()=>{
        return{
			visitor_object:{
				name:'',
				address:'',
				wing_id:'',
			},
			loaders:{
				detail_loader:false,
				submit_loader:false,
			},
			role_list:[],
			loading:false,
			is_office_admin:false,
			loader:null,
			wings_list:[],
			
			valid:false,

		}
    },
    mounted(){
		this.getVisitorDetails();
	},
  };
</script>